<template>

    <div class="flex-grow-1-scroll h-100 no-gutters provider-content" ref="container">
		<div class='d-flex flex-column h-100'>
			<loading ref="loading"></loading>

			<header class="p-2 header__dashboard--top d-flex align-items-center" style="z-index: 100;">
				<h1 class="h2" style="">{{ $t('translations.reports')}}</h1>
			</header>

            <div class="p-3">
                <div id="chart-container">
                    <template>
                        <!-- <template v-if='$root.provider.practice_code == "X99998" || $root.provider.practice_code == "X9999"'> -->
                            <div v-for='(chart, index) in tableau_charts' :key='index' :data-src='chart.src'  class='vizContainer' :id='"vizContainer" + index'>
                                <template v-if='environment_settings.MIX_TABLEAU_VERSION == 3'>
                                    <template v-if='chart.src && chart.token'>
                                        <tableau-viz 
                                                :src='chart.src' 
                                                :token='chart.token' 
                                                :key='index + "-tv"' 
                                                class='vizContainer' 
                                                :id='"vizContainer" + index'
                                                toolbar="bottom">
                                            <viz-filter field="provider_id" :value='provider_id' />
                                        </tableau-viz>
                                    </template>
                                </template>
                            </div>
                        
                        <!-- </template>
                        <template v-else>
                            <div class='alert alert-info'>We are currently performing updates to the Tableau charts, during which time they will be unavailable. We will post a news item and notification when they become available again.</div>
                        </template> -->
                    </template>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
            tableau_charts: [],
            trusted_key: null,
            
            provider_id_query_name: "provider_id",
            viz: [],
            tableau_server: null,
            jwt: null,
        };
    },
    watch: {
        provider_id(new_provider_id, old_provider_id) {
            this.initTableau();
        }
    },
    computed: {
        provider_id: {
            get: function() {
                if(this.is_network_admin()) {
                    return this.$root.admin_provider_id;    
                }
                else {
                    return this.$root.provider.id;
                }
            }
        },
    },
    mounted() {
        this.initTableau();
    },
    methods: {
        initTableau(index, chart) {
            if(this.environment_settings.MIX_TABLEAU_VERSION == 2) {
                if(this.is_network_admin()) {
                    this.tableau_server = this.environment_settings["MIX_LIVE_TABLEAU_SERVER"];
                }
                else {
                    this.tableau_server = this.environment_settings["MIX_HSCN_TABLEAU_SERVER"];
                }
            }
            else {
                this.tableau_server = this.environment_settings["MIX_AWS_TABLEAU_SERVER"];
            }

            switch(this.environment_settings.MIX_TABLEAU_VERSION) {
                case "2":
                    this.initTableauTrustedKey(index, chart);
                    break;
                default:
                    this.initTableauJwt(index, chart);
                    break;
            }
        },
        initTableauJwt(index, chart) {
            var tableau_charts_base = '/#/site/liveaskmygpuk/views';
            // Delete any existing viz components
            this.viz.forEach((value, index) => {
                value.dispose();
                delete(this.viz[index]);
            });

            // Reset the array
            this.viz = [];
            
            axios.get(this.$root.apiBase + "/reports/getJwt").then((res) => {
                this.jwt = res.data;

                var environment = this.environment_settings["MIX_TABLEAU_ENVIRONMENT"] 
                ? this.environment_settings["MIX_TABLEAU_ENVIRONMENT"]
                : "live";
                if(this.is_network_admin()) {
                    this.tableau_charts = [{
                        src: this.tableau_server + tableau_charts_base + "/embedded_charts_na_" + environment + "/Navigation",
                        token: this.jwt,
                    }];
                    
                }
                else {
                    this.tableau_charts = [{
                        //"/views/GPembeddedanalysisv6_0/demandandresolution",
                        src: this.tableau_server + tableau_charts_base + "/embedded_charts_" + environment + "/Navigation",
                        //src: `${this.tableau_server}/#/site/liveaskmygpuk/views/Superstore/Overview`,
                        token: this.jwt,
                    }];
                }
            })
            .catch(error => {
                this.handleError(error, "reports");
            });
        },
        initTableauTrustedKey(index, chart) {
            var tableau_charts_base = '/views/embedded_charts';

            var environment = this.environment_settings["MIX_TABLEAU_ENVIRONMENT"] 
                ? this.environment_settings["MIX_TABLEAU_ENVIRONMENT"]
                : "live";
            if(this.is_network_admin()) {
                this.tableau_charts = [{                  
                    src: tableau_charts_base + "_na_" + environment + "/Navigation",
                    token: null,
                }];
            }
            else {
                this.tableau_charts = [{
                    //"/views/GPembeddedanalysisv6_0/demandandresolution",
                    src: tableau_charts_base + "_" + environment + "/Navigation",
                    token: null,
                }];
            }

            // Delete any existing viz components
            this.viz.forEach((value, index) => {
                value.dispose();
                delete(this.viz[index]);
            });

            // Reset the array
            this.viz = [];
            
            axios.get(this.$root.apiBase + "/reports/getTableauTrustedKey").then((res) => {
                this.trusted_key = res.data;

                var containerDivs = document.getElementsByClassName("vizContainer");

                for(var containerLoop = 0; containerLoop < containerDivs.length; containerLoop++) {
                    var url = this.tableau_server
                            + "/trusted/" + this.trusted_key
                            + containerDivs.item(containerLoop).dataset.src
                            + "?" + this.provider_id_query_name + "=" + this.provider_id;
                    
                    var options = {
                        hideTabs: false,
                    };
                    //console.info("Report URL: " + url);
                    this.viz.push(new tableau.Viz(containerDivs.item(containerLoop), url, options));
                }

            });

            return;
        },
    }
}
</script>
